import * as moment from 'moment';
import { format } from './constants';

export function formatTimeStamp(value: number, customFormat?: string) {
    customFormat = customFormat || format;
    let result: string;
    if (isNaN(value)) {
        result = '-';
    } else if (value || value === 0) {
        result = moment.unix(value).format(customFormat);
    } else {
        result = '-';
    }
    return result;
}